export const pluginKey = 'c8c6c324-097c-426f-98d0-7d5d1bf385a3'
